<template>
  <div class="cabinet-profile cabinet-page" :class="{ 'is-loading': isLoading }">
    <cabinet-page-header :eyebrow="$t('profile.eyebrow')" :title="$t('profile.title')" :subtitle="$t('profile.subtitle')" />
    <app-page-loader v-if="isLoading" />
    <cabinet-state v-else-if="loadError" type="error" :title="$t('profile.unavailable')" @retry="loadProfile" />
    <template v-else>
      <employee-summary :employee="profile.employee" />
      <div class="cabinet-profile__cards">
        <info-card :title="$t('profile.employment')" :rows="profile.employment" />
        <info-card :title="$t('profile.contacts')" :rows="profile.contacts" />
        <info-card :title="$t('profile.salaryPayment')" :rows="profile.salary" />
      </div>
    </template>
  </div>
</template>

<script>
import { getPersonalCabinetProfile } from '@/http'
import EmployeeSummary from './EmployeeSummary'
import InfoCard from './InfoCard'
import CabinetPageHeader from './CabinetPageHeader'
import CabinetState from './CabinetState'
import { normalizeProfile } from './employeeData'

export default {
  name: 'PersonalCabinetProfile',
  components: { EmployeeSummary, InfoCard, CabinetPageHeader, CabinetState },
  data() {
    return {
      isLoading: true,
      loadError: false,
      profileData: {},
    }
  },
  computed: {
    profile() {
      return normalizeProfile(this.profileData)
    },
  },
  created() {
    this.loadProfile()
  },
  methods: {
    loadProfile() {
      this.isLoading = true
      this.loadError = false
      return getPersonalCabinetProfile()
        .then(response => { this.profileData = response.data })
        .catch(() => { this.loadError = true })
        .finally(() => { this.isLoading = false })
    },
  },
}
</script>

<style lang="sass" scoped>
.cabinet-profile
  position: relative
  min-height: calc(100vh - 40px)

.cabinet-profile__cards
  display: grid
  gap: 16px
  margin-top: 16px
</style>
